import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MatDialog } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MyServiceService } from '../../my-service.service';

@Component({
  selector: 'app-edit-sensor-dialog',
  templateUrl: './edit-sensor-dialog.component.html',
  styleUrls: ['./edit-sensor-dialog.component.scss']
})
export class EditSensorDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EditSensorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public myService: MyServiceService) { }

  public sensor_id = this.data.id
  public lat = this.data.lat;
  public lng = this.data.lng;
  public slot = this.data.slot;

  ngOnInit() {
    var sid = document.getElementById('sensor-id') as HTMLInputElement
    sid.placeholder = this.sensor_id
  }

  saveSensor() {
    this.myService.editSensor(this.sensor_id, this.lat, this.lng, this.slot).subscribe(res => {
      this.dialogRef.close()
    })
    this.dialogRef.close()
  }

  cancelProcedure() {
    this.dialogRef.close()
  }

}
